import React, { useEffect, useState } from "react";
import NavBarButton from "../buttons/NavBarButton";
import { useAuth } from "../auth/FirebaseAuth";

import { useLocation } from "react-router-dom";
import Space from "../layout/Space";
import NavBarButtonParam from "../buttons/NavBarButtonParam";

function ParametersNavBar({
  actualpage,
  override_id = null,
  navigateWorkspace,
  userData,
  orgData,
}) {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  const handleFetchData = async () => {};

  useEffect(() => {
    if (userData) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [userData]); // Dependency array ensures this runs when currentUser changes

  if (loading || !currentUser || !userData) {
    return <div></div>; // Show loading state while checking auth or if currentUser is null
  }

  return (
    <div className="flex mt-8 flex-col w-fit min-w-52 h-full pointer-events-auto max-h-full overflow-y-auto  pb-20 pl-4 pr-4 bg-white border-r-1 border-shadow_10">
      <div className="text-hx font-medium">Paramètres</div>
      <Space y={27} />
      {/* Navigation buttons */}
      <NavBarButtonParam
        icon="user"
        isActualPage={
          location.pathname.includes("/account") ||
          location.pathname.includes("/parameters")
        }
        onClick={() => navigateWorkspace("/account", orgData)}
      >
        Compte
      </NavBarButtonParam>
      <NavBarButtonParam
        icon="organisation"
        isActualPage={location.pathname.includes("/organisation")}
        onClick={() => navigateWorkspace("/organisation", orgData)}
      >
        Entreprise
      </NavBarButtonParam>{" "}
      <NavBarButtonParam
        icon="file"
        isActualPage={location.pathname.includes("/ath")}
        onClick={() => navigateWorkspace("/ath", orgData)}
      >
        ATH
      </NavBarButtonParam>{" "}
      <NavBarButtonParam
        icon="rtb"
        isActualPage={location.pathname.includes("/rtb")}
        onClick={() => navigateWorkspace("/rtb", orgData)}
      >
        RT Batiment
      </NavBarButtonParam>{" "}
      <NavBarButtonParam
        icon="facturation"
        isActualPage={location.pathname.includes("/facturation")}
        onClick={() => navigateWorkspace("/facturation", orgData)}
      >
        Facturation
      </NavBarButtonParam>
    </div>
  );
}

export default ParametersNavBar;
